// @flow
export { default } from "./RichTextWithButtons";
